import { Component, Inject, OnInit, EventEmitter, Output } from "@angular/core";
import { DatePipe, Time } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { EditGuestModel } from "../Guests";
import { ParkForReservedSubscriber } from "../../../dataTypes/ParkForReservedSubscriber";
import './dialog-overlay.css';
import { ViewEncapsulation } from "@angular/core";

import * as moment from 'moment';

@Component({
  selector: 'editGuest-dialog',
  templateUrl: './editGuest.dialog.html',
  styleUrls: ['./edit-guest-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditGuestDialog { 

  public _startDate: Date;
  public _endDate: Date;
  public startTime: string = "00:00";
  public endTime: string = "00:00";
  public _errorString: string;

  //----------
  public _isVertical: boolean = false; // Add the isVertical flag
  //----------

  public _selectedDestinedPark: number;
  public parksForDestinedGuest: ParkForReservedSubscriber[];

  @Output() OnSaveEvent = new EventEmitter<any>(true);

  constructor(
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<EditGuestDialog>,

    @Inject(MAT_DIALOG_DATA) public _EditGuestDialogModel: EditGuestModel) {

    if (this._EditGuestDialogModel.isAtidim === true && _EditGuestDialogModel.parksForDestinedGuest.length > 0) {
      this._selectedDestinedPark = _EditGuestDialogModel.parksForDestinedGuest[0].id;
      this.parksForDestinedGuest = _EditGuestDialogModel.parksForDestinedGuest;
    }

    if (_EditGuestDialogModel.isEdit === false) {// new 'YYYY-MM-DD'
      this._startDate = new Date();
      this._endDate = new Date();
      this._endDate.setDate(this._startDate.getDate() + 1); // add one day to today
    }
    else { // edit  | date:'dd-MM-yyyy'
      this._startDate = new Date(this._EditGuestDialogModel.guest.entranceDate);
      this.startTime = this._EditGuestDialogModel.guest.entranceDate.substring(11, 16);
      this._endDate = new Date(this._EditGuestDialogModel.guest.exitDate);
      this.endTime = this._EditGuestDialogModel.guest.exitDate.substring(11, 16);

      if (this._EditGuestDialogModel.isAtidim === true && _EditGuestDialogModel.guest.destinedPark) {
        this._selectedDestinedPark = _EditGuestDialogModel.parksForDestinedGuest.find(x => x.id === _EditGuestDialogModel.guest.destinedPark).id;

        if (!this._selectedDestinedPark) {

          this._selectedDestinedPark = _EditGuestDialogModel.parksForDestinedGuest[0].id;

        }
      }
    }
  }


  //------------------
  ngOnInit() {
    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation.bind(this));
  }

  updateOrientation() {
    this._isVertical = window.matchMedia('(orientation: portrait)').matches;
  }
  //--------------------


  onSaveClick(): void {

    const [hs, ms] = this.startTime.split(":");
    let hoursStart = Number.parseInt(hs), minutesStart = Number.parseInt(ms);

    try {
      if (this._startDate instanceof Date) {
        this._startDate.setHours(hoursStart, minutesStart);
        this._startDate.setSeconds(0);
      }
      else {
        const dmh = moment(this._startDate);
        dmh.set('hour', hoursStart).set('minute', minutesStart);
        this._startDate = dmh.toDate();
      }

    } catch (e) {
      console.log(e);
    }

    // ---- End Time Section
    const [he, me] = this.endTime.split(":");
    let hoursEnd = Number.parseInt(he), minutesEnd = Number.parseInt(me);
    try {
      console.log(this._endDate.toString());
      if (this._endDate instanceof Date) {
        this._endDate.setHours(hoursEnd, minutesEnd);
        this._endDate.setSeconds(0);
      }
      else {
        const dmh = moment(this._endDate);
        dmh.set('hour', hoursEnd).set('minute', minutesEnd);
        this._endDate = dmh.toDate();

      }
    } catch (e) {
      console.log(e);
    }

    this._EditGuestDialogModel.guest.entranceDate = this.datePipe.transform(this._startDate, 'yyyy-MM-dd HH:mm');

    // set end date for new guest
    if (this._EditGuestDialogModel.isEdit === false && this._EditGuestDialogModel.AllowEditGuestEndDate === false) {
      this._EditGuestDialogModel.guest.exitDate = '';
    }
    else {
      this._EditGuestDialogModel.guest.exitDate = this.datePipe.transform(this._endDate, 'yyyy-MM-dd HH:mm');
    }

    this._EditGuestDialogModel.guest.destinedPark = this._selectedDestinedPark;

    if (this.InputFieldsAreValid() === true) {
      //this.dialogRef.close(this._EditGuestDialogModel.guest); // Alex 
      this.OnSaveEvent.emit(this._EditGuestDialogModel.guest);
      console.log('Guest Validation passed'); 
    }
    else {
      // show alert
      console.log('Guest Validation failed');      
    }

  }
  onNoClick(): void {
    this.dialogRef.close();
    location.reload();
  }

  InputFieldsAreValid(): boolean {

    if (this._EditGuestDialogModel.guestValidateIdentityNumber === true && this._EditGuestDialogModel.isEdit === false) {
      if (!this._EditGuestDialogModel.guest.identityNumber) {
        this._errorString = 'IdentityNumberisarequiredfield', 'error';
        return;
      }
    }

    const identityRe = /^\d+$/;
    if (this._EditGuestDialogModel.guestValidateIdentityNumber && this._EditGuestDialogModel.isEdit === false) {
      if (!identityRe.test(String(this._EditGuestDialogModel.guest.identityNumber))) {
        this._errorString = 'InvalidformatofIdentityNumber';
        return;
      }
    }

    if (!this._EditGuestDialogModel.guest.carNo) {
      this._errorString = 'CarNumbercantbeempty', 'error';
      return;
    }

    const carRe = /^\d+$/;
    if (!carRe.test(this._EditGuestDialogModel.guest.carNo)) {
      this._errorString = 'InvalidformatofCarNumber', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.firstName) {
      this._errorString = 'FirstNameCantbeempty', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.lastName) {
      this._errorString = 'LastNamecantbeempty', 'error';
      return;
    }

    if (!this._EditGuestDialogModel.guest.entranceDate) {
      this._errorString = 'Datecantbeempty', 'error';
      return;
    }

    if (this._endDate < new Date() || this._startDate < new Date(2000, 1, 1)) {

      this._errorString = 'DatesInvalid', 'error';
      return;
    }

    
    if (!this._EditGuestDialogModel.guest.exitDate && this._EditGuestDialogModel.AllowEditGuestEndDate === true) {
      this._errorString = 'EndDatecantbeempty', 'error';
      return;
    }

    return true;
  }

  endDatemodelchange(value) {
    console.log( 'endDatemodelchange ' + value);          //Changed Value
    console.log(this._endDate);  //undefined
  }
}
